import { render, staticRenderFns } from "./Room.vue?vue&type=template&id=14a96fc4&scoped=true&"
import script from "./room.js?vue&type=script&lang=js&"
export * from "./room.js?vue&type=script&lang=js&"
import style0 from "./Room.vue?vue&type=style&index=0&id=14a96fc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a96fc4",
  null
  
)

export default component.exports